<script>

export default {
    props: {
        page: {
            required: true,
        }
    },
}
</script>

<template>
  <div class="iframe-container">
    <iframe :srcdoc="page" frameborder="0" allowfullscreen></iframe>
  </div>
</template>

<style lang="scss" scoped>
    .iframe-container {
        width: 100%;
        height: 100%;
        max-height: 800px;
        max-width: 500px;

        background-color: whitesmoke;
        border-radius: 1em;

        > iframe {
            width: 100%;
            height: 100%;

            display: flex;
            justify-content: center;
            align-content: center;
            align-items: center;

            border-radius: 1em;
        }
    }
</style>
